
//API
export default {
  filters: {
    hideMobile(mob) {
      if (mob.length > 7) {
        var new_mobile = mob.substr(0, 3) + "****" + mob.substr(7);
      }
      return new_mobile;
    },
    hideEmail(email) {
      if (email) {
        var email1 = email.split('@')[0];
        var email2 = email.split('@')[1];
        var new_email = email1.substr(0, 3) + "****" + "@" + email2;
      }
      return new_email
    },
  },
  data() {
    return {
      loginError: null,
      clientId: "",
      token: "",

      appId: "applicant",
      randomVal: ""
    }
  },
  computed: {
    axios() {
      return this.$tquery.getApi("root")
    },
    //FIXME 貌似没用
    loginFlag: {
      get() {
        var flag = window.localStorage.getItem("ef-ent-loginFlag");
        if (flag != null) {
          return JSON.parse(flag);
        } else {
          return {
            flag: "sms"
          }
        }
      },
      set(val) {
        window.localStorage.setItem("ef-ent-loginFlag", JSON.stringify(val));
      }
    },
    //验证码地址
    validImageUrl() {
      return `/web/imageCodes?v=${this.randomVal}`;
    }
  },
  methods: {
    //刷新验证码
    refreshValidationImage() {
      this.randomVal = new Date().getMilliseconds();
    },
    //www主页
    goHome() {
      window.location.href = "https://www.beilie.com"
    },
    //WWW上传简历后自动登录
    quickLogin(token) {
      return this.axios.post(`/web/applicant/login/${token}/token`).then(() => {
        return { success: true }
      }).catch(({ data }) => {
        return { success: false, message: data }
      })
    },
    //检查邮箱是否注册过
    // GET /web/applicant/email/exist
    checkEmailExist() {
      this.axios.get("/web/applicant/email/exist")
    },
    // DELETE /web/applicant/login求职者端登出
    loginOut() {

    },
    //检查手机号是否注册过【DONE】
    // GET /web/applicant/mobile/exist
    async checkMobileExist(mobile) {
      return this.axios.get("/web/applicant/mobile/exist", {
        params: {
          mobile
        }
      }).then((res) => {
        return { success: res.data.success, data: res.data.data, message: res.data.message }
      }).catch(({ data: message }) => { success: false, message })
    },
    //【DONE】
    register(mobile, verifyCode) {
      const { appId } = this;
      return this.axios.post('/web/applicant/register', { appId, mobile, verifyCode }).then((res) => {
        return {
          success: true,
        }
      }).catch(({ data }) => {
        return {
          success: false,
          message: data
        }
      })
    },





    //发送登录短信
    // POST /web/applicant/verifyCodes/login发送求职者登录验证码

    //重置密码短信校验
    // GET /web/applicant/verifyCodes/password验证重置密码的验证码
    checkResetPasswordSms(mobile, verifyCode) {
      return this.axios.get('/web/applicant/verifyCodes/password', { params: { mobile, verifyCode } })
    },
    //发送重置短信
    // POST /web/applicant/verifyCodes/password发送重置密码的验证码
    async sendResetPasswordSMS(mobile, token) {
      return await this.axios.post('/web/applicant/verifyCodes/password', { mobile, token }).then(res => {
        if (res.status == "200") {
          return {
            success: res.data.data,
            message: res.data.message
          }
        } else
          return {
            success: false,
            message: "发送验证码失败"
          };
      }).catch(err => {
        return {
          success: false,
          message: "发送验证码失败"
        };
      });
    },






    //FIXME 需要服务端增加发送邮件
    async sendEmail(email) {
      return await this.axios.post(`/web/send/email`, { email }).then(res => {
        return {
          success: res.data.success,
          message: res.data.message,
        }
      }).catch(({ data }) => {
        return {
          success: false,
          message: data
        }
      })

    },

    //重置密码SMS校验，并获取token
    resetPasswordValidationBySMS(mobile, verifyCode) {
      return this.axios.get(`/web/applicant/verifyCodes/password`, { params: { mobile, verifyCode } }).then(({ data: res }) => {
        return {
          success: res.success,
          message: res.message,
          data: res.data
        }
      }).catch(({ data }) => {
        return {
          success: false,
          message: data
        };
      });
    },

    //重置通过token重置密码
    async resetPasswordByToken(mobile, token, newPassword) {
      return await this.axios.put(`/web/applicant/mobile/${mobile}/password`, {
        token,
        newPassword
      }).then(({ data: res }) => {
        return {
          success: res.success,
          message: res.success ? "重置密码成功" : "重置密码失败"
        }
      }).catch(err => {
        return {
          success: false,
          message: "重置密码失败"
        };
      });
    },

    // //重置密码-确认
    // async resetPasswd(mobile, userName, token, password) {
    //   return await this.axios.put(`/shield/reset/${mobile}/password`, {
    //     newPassword: password,
    //     token: token,
    //     userName: userName,
    //     userType: "Applicant"
    //   }).then(res => {
    //     if (res.status == "200") {
    //       return {
    //         success: res.data.data,
    //         message: res.data.message
    //       }
    //     } else
    //       return {
    //         success: false,
    //         message: "重置密码错误"
    //       };
    //   }).catch(err => {
    //     return {
    //       success: false,
    //       message: "重置密码错误"
    //     };
    //   });
    // },
    //发送登录短信【DONE】
    async sendLoginSMS(mobile, token) {
      return await this.axios.post('/web/applicant/verifyCodes/login', { mobile, token }).then(res => {
        return res.data
      }).catch(({ status, data }) => {
        return {
          success: false,
          message: data
        };
      });
    },
    //发送注册短信【DONE】
    async sendRegisterSMS(mobile, token) {
      return await this.axios.post(`/web/applicant/verifyCodes/register`, { mobile, token }).then(res => {
        return {
          success: res.data.success,
          message: res.data.message
        }
      }).catch(({ data }) => {
        return {
          success: false,
          message: data
        };
      });
    },
    //密码验证登录[DONE]
    loginByPassword(loginName, password, token) {
      const { appId } = this;

      return this.axios
        .post("/web/applicant/login", {
          appId,
          loginName,
          password: btoa(password),
          token
        }).then(({ data }) => {
          return data
        })
    },

    //短信验证登录
    // POST /web/applicant/login/verifyCode
    loginBySms(mobile, verifyCode) {
      const { appId } = this;
      return this.axios.post('/web/applicant/login/verifyCode', { appId, mobile, verifyCode }).then(({data}) => {
        return data
      })
    },

  },
}
